<template>
  <div id="add-conferences">
    <!--  -->
    <ipub-model :title="params.id?'Edit Conference':'Add New Conference'"
                width="900px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <ipub-form ref="conferences-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Full name of the conference">
          <ipub-input placeholder="Full name of the Conference"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="picture"
                        label="Image Upload">
          <div slot="label"
               class="ipub-p2 fw-bd mar-b-10">
            Image Upload <font class="key-color">*</font>
            <ipub-tooltip placement="right"
                          class="mar-l-10">
              <div slot="title">
                <div class="font-color ipub-p4">
                  Suggested Size: 665 * 265px
                  Only support .png; File size need to be less than 500KB.</div>
              </div>
              <ipub-icon type="iconInfo" />
            </ipub-tooltip>
          </div>
          <ipub-upload-cropper @change="handleUpload"
                               :canWidth="canWidth"
                               :canHeight="canHeight"
                               :size="500"
                               :domain="domain"
                               :imgUrl="params.picture" />
        </ipub-form-item>
        <ipub-row :gutter="12">
          <ipub-col :span="6"
                    class="relative">
            <ipub-form-item prop="startTime"
                            label="Start Time">
              <ipub-date-time-picker placeholder="Begin Time"
                                     v-model="params.startTime" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6"
                    class="relative">
            <ipub-form-item prop="endTime"
                            label="End Time">
              <ipub-date-time-picker placeholder="End Time"
                                     v-model="params.endTime" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="10">
            <ipub-form-item prop="location"
                            label="Location">
              <ipub-input placeholder="Location"
                          v-model.trim="params.location" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="2"
                    class="relative">
            <ipub-form-item prop="hierarchy"
                            label="Hierarchy">
              <ipub-input placeholder="Hierarchy"
                          number
                          v-model.trim="params.sort" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row>
          <ipub-col>
            <ipub-form-item prop="linked"
                            label="">
              <div class="ipub-p1 mar-b-10"
                   slot="label">
                Links
                <font class="key-color">*</font>
              </div>
              <ipub-radio-group class="mar-b-10"
                                v-model="params.linked"
                                _label="name"
                                :options="[{name:'Yes',value:true},{name:'No',value:false}]" />
            </ipub-form-item>
            <ipub-form-item prop="linkAddress"
                            label=""
                            v-if="params.linked">

              <ipub-input placeholder="Enter link here"
                          v-model.trim="params.linkAddress" />
            </ipub-form-item>
            <ipub-form-item prop="linkText"
                            label=""
                            v-else>
              <ipub-editor :height="200"
                           v-model.trim="params.linkText" />
            </ipub-form-item>
          </ipub-col>

        </ipub-row>
      </ipub-form>
      <div>
        <ipub-button type="primary"
                     plain
                     style="width:120px"
                     @click="cancel">
          Cancel
        </ipub-button>
        <ipub-button v-if="params.id"
                     type="primary"
                     plain
                     style="width:120px"
                     @click="submit('save')">
          Save
        </ipub-button>
        <ipub-button v-else
                     type="primary"
                     plain
                     style="width:120px"
                     @click="submit('save')">
          Save as Draft
        </ipub-button>
        <ipub-button type="primary"
                     style="width:120px"
                     @click="submit('publish')"
                     v-show="!params.released">
          Publish
        </ipub-button>

      </div>

    </ipub-model>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import conferences from '@/api/conferences'
import check from '@/utils/check'
import help from '@/utils/help'


export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      params: {
        linked: false
      },
      rules: {},
      canWidth: 665,
      canHeight: 265,
    }
  },
  computed: {
    ...mapGetters({
      journalId: 'getJournalId',
      domain: 'getDomain',
      language: 'getLanguage',
      publisherId: 'getPublisherId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          linked: false
        }
      }
    }
  },
  mounted () {
    this.getRules()
    help.closeAutocomplete()
  },
  methods: {
    async getQuery (id) {
      const res = await conferences.query(id)
      this.params = res
      this.startTime = this.$moment(res.startTime).format('YYYY-MM-DD')
      this.startHour = this.$moment(res.startTime).hours().toString()
      this.startMinute = this.$moment(res.startTime).minutes().toString()
      this.endTime = this.$moment(res.endTime).format('YYYY-MM-DD')
      this.endHour = this.$moment(res.endTime).hours().toString()
      this.endMinute = this.$moment(res.endTime).minutes().toString()
      if (this.startHour.toString().length < 2) {
        let sth = this.startHour.toString().length > 1 ? this.startHour.toString() : '0' + this.startHour
        this.startHour = sth
      }
      if (this.startMinute.toString().length < 2) {
        let stm = this.startMinute.toString().length > 1 ? this.startMinute.toString() : '0' + this.startMinute
        this.startMinute = stm
      }
      if (this.endHour.toString().length < 2) {
        let enh = this.endHour.toString().length > 1 ? this.endHour.toString() : '0' + this.endHour
        this.endHour = enh
      }
      if (this.endMinute.toString().length < 2) {
        let enm = this.endMinute.toString().length > 1 ? this.endMinute.toString() : '0' + this.endMinute
        this.endMinute = enm
      }
    },
    async submit (ststus) {
      const flag = this.$refs['conferences-add-form'].validate()
      if (this.params.linked) {
        if (!this.params.linkAddress || !check.website(this.params.linkAddress)) {
          this.$message.error({ title: 'Error', content: this.LANGUAGE[this.language].enterCorrent + 'Link' })
          return
        }
      }
      if (flag) {
        if (!this.params.released) {
          ststus === 'save' ? this.params.released = false : this.params.released = true
        }
        const data = Object.assign(this.params, {
          journalId: this.journalId,
        })
        if (this.params.id) {
          await conferences.edit(this.params.id, data)
          this.$message.success({ title: 'Success', content: 'This Conference has been saved!' })
        } else {
          await conferences.add(data)
          this.$message.success({ title: 'Success', content: 'This Conference has been saved!' })
        }
        this.$emit('confirm', data)
      }
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Title' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        picture: [
          {
            required: true,
            message:
              'Picture' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        linkText: [
          {
            required: true,
            message:
              'LinkText' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    async handleUpload (files) {
      const file = files[0]
      const types = ['image/jpeg', 'image/png']
      const rightType = types.includes(file.type)
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.journalId}/partner`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, 'pictureName', file.name)
      this.$set(this.params, 'picture', url)
    },
  }
}
</script>
<style lang="scss" scoped>
.upload-content {
  height: 180px;
  width: 426px;
  background: $content_color;
  border: 1px solid $border_color;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
